import { action } from 'satcheljs';
import { CalendarCacheInitializationLoadState } from '../store/schema/CalendarCacheInitializationState';
import { CalendarCacheScenarioId } from '../store/schema/CalendarCacheScenarioId';

export const calendarCacheInitializedInternal = action(
    'calendarCacheInitializedInternal',
    (mailboxId?: string) => ({ mailboxId })
);
export const calendarCacheInitializeFailedInternal = action(
    'calendarCacheInitializeFailedInternal',
    (mailboxId?: string) => ({ mailboxId })
);
export const clearLoadingScenarios = action('clearCalendarCacheInitializationLoadingScenarios');
export const addLoadingScenario = action(
    'addCalendarCacheInitializationLoadingScenario',
    (calendarCacheScenarioId: CalendarCacheScenarioId) => ({ calendarCacheScenarioId })
);
export const setLoadState = action(
    'setCalendarCacheInitializationLoadState',
    (
        calendarCacheInitializationLoadState: CalendarCacheInitializationLoadState,
        mailboxId?: string
    ) => ({
        calendarCacheInitializationLoadState,
        mailboxId,
    })
);

export const removeCalendarWithIDFromCalendarsCache = action(
    'removeCalendarWithIDFromCalendarsCache',
    (calendarId: string) => ({ calendarId })
);
